<script setup lang="ts">
import type { ImageType } from "@/types";

type PropsType = {
  content: {
    image: ImageType;
  };
};

const props = defineProps<PropsType>();
const image = ref(props?.content?.image);
</script>

<template>
  <section class="simple-image">
    <img
      v-if="image?.url"
      :src="useStrapiMedia(image?.url)"
      :alt="image?.alternativeText || ''"
      class="simple-image__img"
    />
  </section>
</template>

<style lang="scss" scoped>
.simple-image {
  &__img {
    @apply w-full h-auto object-contain max-w-full;
  }
}
</style>
